import { useContext } from "react";
import { Container, Grid, Paper, styled, Link as MuiLink } from "@mui/material";
import { AppContext, AppDispatchContext } from "Contexts/AppContext";
import CentralizedLayout from "./CentralizedLayout";
import { useNavigate } from "react-router-dom";

const scenes: string[] = ["Warehouse", "Seaport", "SpaceX"];

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: "center",
    verticalAlign: "middle",
    color: theme.palette.text.secondary,
    elevation: 16,
    fontFamily: "Azonix",
}));

const ScenesPage: React.FC = () => {
    const appConfig = useContext(AppContext);
    const dispatch = useContext(AppDispatchContext);
    const navigate = useNavigate();

    const onSceneSelected = (e: any, scene: string) => {
        // check if user is logged in. Presence of appConfig.profile indicates logged in.
        // Otherwise, navigate to LoginPage component.
        dispatch({
            type: "setScene",
            payload: {
                scene,
            },
        });
        if (!appConfig.profile) {
            navigate("/login", { state: { from: "/scenes" } });
        } else {
            navigate("/avatars");
        }
    };
    return (
        <CentralizedLayout>
            <Container
                maxWidth={false}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    overflow: "auto",
                }}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    spacing={2}
                    columns={16}
                    margin={"auto"}
                >
                    {scenes.map((scene: string) => (
                        <Grid item xs={16} sm={4} md={3} key={scene}>
                            <Item>
                                <img
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "cover",
                                    }}
                                    src={`https://bwland-scenes-artifacts.s3.ap-southeast-1.amazonaws.com/default-scenes/${scene}_Thumbnail.png`}
                                />
                                <div>
                                    <p>
                                        <MuiLink
                                            className="bw-bgcolor"
                                            sx={{
                                                borderRadius: 1,
                                                py: "0.6rem",
                                                columnGap: "1rem",
                                                textDecoration: "none",
                                                color: "#fff",
                                                cursor: "pointer",
                                                fontWeight: 500,
                                                "&:hover": {
                                                    className: "bw-color",
                                                    boxShadow:
                                                        "0 1px 13px 0 rgb(0 0 0 / 55%)",
                                                },
                                                mb: 1,
                                            }}
                                            display="flex"
                                            justifyContent="center"
                                            alignItems="center"
                                            onClick={(e) =>
                                                onSceneSelected(e, scene)
                                            }
                                        >
                                            {scene}
                                        </MuiLink>
                                    </p>
                                </div>
                            </Item>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </CentralizedLayout>
    );
};

export default ScenesPage;
